module.exports = __webpack_public_path__ + "img/9791195785742.acfe168b.jpg";